<template>
  <select class="form-control" @change="changed" ref="select">
    <option
      v-for="step in timeSteps"
      :key="step.value"
      :value="step.value"
      :selected="step.value === normalizedValue"
    >{{step.text}}</option>
  </select>
</template>

<script>
const minutesInDay = 60 * 24
const minSteps = 5 // minutes
const maxSteps = 60 // 1 hour

export default {
  name: 'time-picker',
  props: {
    stepSize: {
      type: Number,
      default: 30, // minutes
      coerce(val) {
        return parseInt(val, 10)
      },
      validator(value) {
        return Number.isInteger(value) && value >= minSteps && value <= maxSteps
      }
    },
    value: {
      default: '0' // minutes
    },
    validity: {
      default: ''
    },
    includeBeforeMidnight: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    // set initial validity since watcher requires a frame
    this.$refs.select.setCustomValidity(this.validity)
  },

  watch: {
    validity(newVal, oldVal) {
      this.$refs.select.setCustomValidity(newVal)
    }
  },

  methods: {
    changed(e) {
      this.$emit('input', e.target.value)
    }
  },

  computed: {
    normalizedValue() {
      return this.value ? this.value.toString() : '0'
    },

    timeSteps() {
      let steps = []
      for (let i = 0; i < minutesInDay; i += this.stepSize) {
        let hours = Math.floor(i / 60)
        let minutes = i % 60

        steps.push({
          text: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`,
          value: `${i}`
        })
      }

      if (this.includeBeforeMidnight && !steps.find(step => step.value === '1439')) {
        steps.push({
          text: `23:59`,
          value: `${23 * 60 + 59}` // 1439 minutes
        })
      }

      return steps
    }
  }
}
</script>
